import React from 'react';
import { Shield, Lock, Activity } from 'lucide-react';

export function Logo({ className = '' }: { className?: string }) {
  return (
    <div className={`relative ${className}`}>
      {/* Main shield with gradient background */}
      <div className="relative">
        <svg
          className="logo-svg w-full h-full"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ filter: 'drop-shadow(0 4px 6px rgba(37, 99, 235, 0.3))' }}
        >
          {/* Background gradient */}
          <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{ stopColor: '#3B82F6' }} />
              <stop offset="100%" style={{ stopColor: '#2563EB' }} />
            </linearGradient>
          </defs>
          
          {/* Shield shape */}
          <path
            d="M12 2L3 7V12C3 16.97 7.02 21.5 12 22C16.98 21.5 21 16.97 21 12V7L12 2Z"
            fill="url(#logoGradient)"
          />
          
          {/* Lock icon */}
          <path
            d="M8 11V8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8V11M12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14C11 14.5523 11.4477 15 12 15ZM7 11H17V19H7V11Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        
        {/* Decorative pulse effect */}
        <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-400 to-blue-600 opacity-30 blur-sm animate-pulse" />
      </div>
      
      {/* Activity line for cyber aspect */}
      <Activity className="absolute -bottom-1 -right-1 w-3/4 h-3/4 text-blue-400 opacity-50" />
    </div>
  );
}